export default __webpack_public_path__ + "static/media/21_Epi_GG-Quiz-Art_Aplat-Two-Bottle-Tote-Stone_VOG.a14cfc5b.png";